import BottomPanel from "src/components/controls/bottom-panel";
import NavHeader from "@/components/controls/navigation/nav-header";
import NavSideControl from "@/components/controls/navigation/nav-side-control";

import TopViewButton from "src/components/button/top-view-button";
import { useNavigationStore } from "@/store/navigationStore";
import AIAgentPanel from "../controls/ai-agent-panel";
import { useAppStore } from "@/store/appStore";
import ShareDialog from "../dialog/share-dialog";
import { useEffect, useState, useRef } from "react";

import Lottie from "lottie-react";
import dragScreenAnimation from "src/components/lottie/drag_screen.json";

export default function NavigationLayout({
  children,
  referrer,
}: {
  children: React.ReactNode;
  referrer?: string;
}) {
  const AINavigationPanel = () => {
    const showNavAIPanel = useNavigationStore((state) => state.showNavAIPanel);

    return (
      <div
        className={`transition-all transition-transform duration-300 ease-in-out
    ${
      showNavAIPanel ? "translate-y-0 h-[100dvh]" : "translate-y-full h-[85dvh]"
    }
    fixed left-0 right-0 bottom-0`}
        style={{ zIndex: 54 }}
      >
        <AIAgentPanel />
      </div>
    );
  };

  const DragScreenAnimation = () => {
    const isDisplayDragScreenSliderAnimation = useNavigationStore(
      (state) => state.isDisplayDragScreenSliderAnimation,
    );
    return isDisplayDragScreenSliderAnimation ? (
      <div
        className={`fullscreen_div flex items-center justify-center pointer-events-none`}
      >
        <div className={`w-[120px] h-[120px]`}>
          <Lottie animationData={dragScreenAnimation} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const NavigationUI = () => {
    const isDisplayUI = useNavigationStore((state) => state.isDisplayUI);
    return (
      <>
        <NavHeader referrer={referrer} />
        <>
          {isDisplayUI ? (
            <>
              <div className="absolute bottom-0 left-0 right-0">
                <BottomPanel />
              </div>
              <div className="absolute bottom-[184px] md:bottom-20 right-0">
                <NavSideControl />
              </div>
              <div className="absolute bottom-[184px] md:bottom-20 left-0 m-6 mb-[20px] md:mb-[35px]">
                <TopViewButton />
              </div>
              <AINavigationPanel />
              <Share />
              <DragScreenAnimation />
            </>
          ) : (
            <></>
          )}
        </>
        {/* {isShareOpen && <ShareDialog />} */}
      </>
    );
  };

  const Share = () => {
    const isShareOpen = useAppStore((state) => state.isShareOpen);
    return isShareOpen ? <ShareDialog /> : <></>;
  };

  return (
    <div className="fullscreen_div">
      {children}
      <NavigationUI />
    </div>
  );
}
